import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FilterFourService } from '../filter-four/filter-four.service';
import { FilterOneService } from './filter-one.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CommonUtilitiesService } from '../../common-utilities.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-filter-one',
  templateUrl: './filter-one.component.html',
  styleUrls: ['./filter-one.component.scss'],
  providers: [FilterFourService, FilterOneService]  
})
export class FilterOneComponent implements OnInit {

  isLoadingBalance = false;
  form: FormGroup
  tecnologies = []
  provinces = []
  cantons = []
  parishes = []
  filterSend = []
  view_filter_parishes:boolean = false
  view_btn_parishes:boolean = false
  view_btn_search:boolean = false


  isShowModal = false;
  modalTitle = "";
  modalContent = "";
  isModalReload = false;

  @Output() dataFilter = new EventEmitter<any>();

  constructor(
    private filterFourService:FilterFourService,
    private _router: Router,
    private formbuilder:FormBuilder,
    private filterOneService:FilterOneService,
    public LANG: CommonUtilitiesService
  ) { }

  ngOnInit() {
    this.form = this.formbuilder.group({
      techSelec: [''],
      provinceSelec: [''],
      cantonSelec: [''],
      parishSelec:['']
    });
    this.get_technology_coverage_list()
  }

  /**
   * Description: Método que llama el servicio web para obtener todas las tecnologias
   * Autor: Luis Hernandez
   * @return Tecnologias
   */
  get_technology_coverage_list(){
    this.isLoadingBalance = true;
    this.filterFourService.get_technology_coverage_list().subscribe(technologys => {
      this.tecnologies = technologys["obj"]
      this.isLoadingBalance = false;
    });
  }

  /**
   * Description: Método que llama el servicio web para obtener todas las provincias
   * Autor: Luis Hernandez
   * @return Tecnologias
   */
  get_province(){
    this.view_btn_parishes = false
    this.view_btn_parishes = false
    this.view_btn_search = false
    this.view_filter_parishes = false

    this.isLoadingBalance = true;
    this.form.get('provinceSelec').setValue("");
    this.form.get('cantonSelec').setValue("");
    this.filterOneService.get_province(this.form.get('techSelec').value).subscribe(provinces => {
      this.provinces = provinces["obj"]
      this.isLoadingBalance = false;
    });
  }

  /**
   * Description: Método que llama el servicio web para obtener todos los cantones
   * Autor: Luis Hernandez
   * @return Cantones
   */
  get_cantons(){
    this.isLoadingBalance = true;
    this.form.get('cantonSelec').setValue("");
    this.filterOneService.get_cantons(this.form.get('provinceSelec').value).subscribe(cantons => {
      this.cantons = cantons["obj"]
      this.isLoadingBalance = false;
    });
  }

  /**
   * Description: Método que devuelve las parroquias segun los cantones
   * Autor: Luis Hernandez
   */
  get_btns_search_parishes_and_get_parishes(){
    this.view_filter_parishes = false
    this.isLoadingBalance = true;
    this.filterOneService.get_parish(this.form.get('cantonSelec').value).subscribe(parishes => {
      this.parishes = parishes["obj"]
      this.isLoadingBalance = false;
      this.view_btn_parishes = true
      this.view_btn_search = true
    });
  } 

  /**
   * Description: Método que muestra el filtro de parroquias (select)
   * Autor: Luis Hernandez
   */
  get_search_parishes(){
    this.view_filter_parishes = true
    this.view_btn_parishes = false
    this.view_btn_search = false
  }

  /**
   * Description: Método que muestra el boton de consultar parroquias
   * Autor: Luis Hernandez
   */
  get_btns_search_parishes(){
    this.view_btn_search = true
  }

  /**
   * Description: Método que envia la información del filtro
   * Autor: Luis Hernandez
   * @return interación grafica en el mapa
   */
  get_filter(){
    if(
      this.form.get('techSelec').value != "" && 
      this.form.get('provinceSelec').value != "" && 
      this.form.get('cantonSelec').value != ""
      ){

        if(!this.view_filter_parishes){
          this.filterSend = []
          const result  = this.provinces.filter(province => province.name == this.form.get('provinceSelec').value);
          let resultP = []
          if(this.view_filter_parishes){
            resultP = this.parishes.filter(parish => parish.name == this.form.get('parishSelec').value);
          }else{
            resultP = this.cantons.filter(canton => canton.name == this.form.get('cantonSelec').value);
          }
          this.filterSend.push({"filter":1,"data":[],"type":this.form.get('techSelec').value})
          this.filterSend[0].data.push(this.LANG.getLangText('URL_PATH_KML')+result[0].region+"/"+this.form.get('techSelec').value+"/predictions.kml")
          this.filterSend[0].data.push(resultP[0])
          this.dataFilter.emit(this.filterSend)
          this.isLoadingBalance = false;
        }else{
          if(
            this.form.get('techSelec').value != "" && 
            this.form.get('provinceSelec').value != "" && 
            this.form.get('cantonSelec').value != "" &&
            this.form.get('parishSelec').value != ""
          ){
            this.filterSend = []
            const result  = this.provinces.filter(province => province.name == this.form.get('provinceSelec').value);
            let resultP = []
            if(this.view_filter_parishes){
              resultP = this.parishes.filter(parish => parish.name == this.form.get('parishSelec').value);
            }else{
              resultP = this.cantons.filter(canton => canton.name == this.form.get('cantonSelec').value);
            }
            this.filterSend.push({"filter":1,"data":[],"type":this.form.get('techSelec').value})
            this.filterSend[0].data.push(this.LANG.getLangText('URL_PATH_KML')+result[0].region+"/"+this.form.get('techSelec').value+"/predictions.kml")
            this.filterSend[0].data.push(resultP[0])
            this.dataFilter.emit(this.filterSend)
            this.isLoadingBalance = false;
          }else{
            this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
            this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
            this.isShowModal = true;
            this.isLoadingBalance = false;
          }
        }
          
      }else{
        this.modalTitle = this.LANG.getLangText('PORTABILITY_MODAL_TITLE_VALIDATION');
        this.modalContent = this.LANG.getLangText('PORTABILITY_MODAL_CONTENT_VALIDATION');
        this.isShowModal = true;
        this.isLoadingBalance = false;
      }
  }


  /**
   * Description: Método que ocualta el modal
   * Autor: Luis Hernandez
   * @param N/A
   * @return N/A
   */
  hideModal() {
    this.isShowModal = false;
    if (this.isModalReload) {
      this._router.navigate(['/']);
    } 
  }


}
